import { getSessionUUID } from '../components/lib/AuthToken';
import logger from '../utils/logger';

const authHeaders = async () => {
    const token = await getSessionUUID();
    return { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
};

export const fetch_all_subcontractors = async () => {
    try {
        const response = await fetch('/subcontractors/get_all', { headers: await authHeaders() });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error fetching sub-contractors:', err);
        return { status: 500, message: err.message };
    }
};

export const add_subcontractor = async (record) => {
    try {
        const response = await fetch('/subcontractors/add', {
            method: 'POST',
            headers: await authHeaders(),
            body: JSON.stringify(record),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error adding sub-contractor:', err);
        return { status: 500, message: err.message };
    }
};

export const update_subcontractor = async (id, record) => {
    try {
        const response = await fetch(`/subcontractors/update/${id}`, {
            method: 'PUT',
            headers: await authHeaders(),
            body: JSON.stringify(record),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error updating sub-contractor:', err);
        return { status: 500, message: err.message };
    }
};

export const delete_subcontractor = async (id) => {
    try {
        const response = await fetch(`/subcontractors/delete/${id}`, {
            method: 'DELETE',
            headers: await authHeaders(),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error deleting sub-contractor:', err);
        return { status: 500, message: err.message };
    }
};
